export default __webpack_public_path__ + "static/media/Expand_left.f8e26ec4.svg";